import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const transition = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/transaction/${id}/transition`,
    data,
  })

  return response?.data
}
